var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDoubleUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline/chevron-double-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52794 2.19526C7.78829 1.93491 8.2104 1.93491 8.47075 2.19526L13.1374 6.86193C13.3978 7.12228 13.3978 7.54439 13.1374 7.80474C12.8771 8.06509 12.455 8.06509 12.1946 7.80474L7.99935 3.60948L3.80409 7.80474C3.54374 8.06509 3.12163 8.06509 2.86128 7.80474C2.60093 7.54439 2.60093 7.12228 2.86128 6.86193L7.52794 2.19526ZM7.99935 8.94281L12.1946 13.1381C12.455 13.3984 12.8771 13.3984 13.1374 13.1381C13.3978 12.8777 13.3978 12.4556 13.1374 12.1953L8.47075 7.52859C8.2104 7.26825 7.78829 7.26825 7.52794 7.52859L2.86128 12.1953C2.60093 12.4556 2.60093 12.8777 2.86128 13.1381C3.12163 13.3984 3.54374 13.3984 3.80409 13.1381L7.99935 8.94281Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDoubleUp);
export default __webpack_public_path__ + "static/media/chevron-double-up.755585cd4629cc58a1e5ffdb05d5b039.svg";
export { ForwardRef as ReactComponent };